import styled from '@emotion/styled';
import { isNotEmptyString } from '@racemap/utilities/functions/utils';
import { type FC, useState } from 'react';
import { useIsMobile } from '../../lib/customHooks';
import { AdvancedSearchBar, AskQuestionPanel } from '../BasicComponents/AdvancedSearchBar';
import { PossibleQuestionsList } from './PossibleQuestionsList';

interface Props {
  reactOnShortcut?: boolean; // prevent that multiple search bars are opened if you use multiple on page
}

export const SupportSearchBar: FC<Props> = ({ reactOnShortcut = true }) => {
  const [query, setQuery] = useState('');
  const [question, setQuestion] = useState<string | null>(null);
  const isMobile = useIsMobile();

  const handleSuggestionClick = (suggestion: string) => {
    if (isNotEmptyString(suggestion)) {
      setQuery(suggestion);
    }
    setQuestion(suggestion);
  };

  const handleQueryChangeBySearchBar = (newQuery: string) => {
    setQuery(newQuery);
    setQuestion(null);
  };

  const handleQuestionChangeByAskQuestionPanel = (newQuestion: string | null) => {
    setQuestion(newQuestion);
    setQuery(newQuestion || '');
  };

  return (
    <Container className="support-search-bar">
      <AdvancedSearchBar
        query={query}
        size={isMobile ? 'small' : 'large'}
        onQueryChange={handleQueryChangeBySearchBar}
        reactOnHotkey={reactOnShortcut}
      >
        {query.length > 0 && (
          <AskQuestionPanel
            question={question}
            query={query}
            onChange={handleQuestionChangeByAskQuestionPanel}
          />
        )}
        <PossibleQuestionsList onQuestionClick={handleSuggestionClick} />
      </AdvancedSearchBar>
    </Container>
  );
};

const Container = styled.div`
  width: clamp(220px,230px,240px);
`;
